var React = require('react');

function Leftarrow (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".a15323d0-5f5c-4d8e-9b14-f3fcc4101f8a{fill:#f7f8f3;}")),React.createElement("title",{"key":1},"leftarrow"),React.createElement("g",{"id":"bd9b130a-8bd1-4ba6-939b-3f6d42432c3e","data-name":"Capa 2","key":2},React.createElement("g",{"id":"b79c45d8-6601-4246-b3ff-4fe50735adec","data-name":"Capa 1"},[React.createElement("path",{"className":"a15323d0-5f5c-4d8e-9b14-f3fcc4101f8a","d":"M45,8A37,37,0,1,1,8,45,37,37,0,0,1,45,8m0-8A45,45,0,1,0,90,45,45,45,0,0,0,45,0Z","key":0}),React.createElement("path",{"className":"a15323d0-5f5c-4d8e-9b14-f3fcc4101f8a","d":"M37,64.48,21.83,47.32a4,4,0,0,1,0-5.29l14.5-16.5a4,4,0,0,1,6.08,5.19L33.86,41H68.33a4,4,0,0,1,0,8H34l9,10.18a4,4,0,0,1-6,5.3Z","key":1})]))]);
}

Leftarrow.defaultProps = {"viewBox":"0 0 90 90"};

module.exports = Leftarrow;

Leftarrow.default = Leftarrow;
